import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import {IDepartment} from "../models/departement";
import {DepartementService} from "../services/departement.service";

@Injectable({
  providedIn: 'root'
})
export class DepartmentResolver  {
  constructor(private departementService: DepartementService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IDepartment[]> {
    return this.departementService.listDepartements({pageNumber: 0, pageSize: 999999})
    .pipe(
      map(response => response.data)
    )
  }
}
